module.exports = __webpack_public_path__ + "img/a5-logo.0506ae33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a5-logo.svg
// module id = diO/
// module chunks = 1